import { createSlice } from '@reduxjs/toolkit';

import { initFailed, initSucceeded } from '../../actions/priceMatrixActions';

// Keeps the existing message when the action carries none, on both outcomes.
const messageSlice = createSlice({
  name: 'message',
  initialState: null,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(initSucceeded, (state, action) => action.payload.message ?? state)
      .addCase(initFailed, (state, action) => action.payload.message ?? state);
  },
});

export default messageSlice.reducer;
